import { render, staticRenderFns } from "./AffairsPublic.vue?vue&type=template&id=c5dc2af6&scoped=true"
import script from "./AffairsPublic.vue?vue&type=script&lang=js"
export * from "./AffairsPublic.vue?vue&type=script&lang=js"
import style0 from "./AffairsPublic.vue?vue&type=style&index=0&id=c5dc2af6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5dc2af6",
  null
  
)

export default component.exports